<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!$parent.$parent.$parent.flagNav"
        transition="scale-transition"
        max-height="64" 
        type="table-heading"
        >
        <v-toolbar dark class="header-title">
          <v-toolbar-title class="title">{{
            $t("managementGPTModelNode")
          }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-title class="title">{{ today }}</v-toolbar-title>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row style="margin-top: 1rem">
            <v-col cols="3" class="mt-3">
              <v-text-field
                :label="'Node Name'"
                v-model="searchNodeName"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <v-btn fab class="primary white--text mt-3" @click="Search">
                <v-icon size="30">mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6" justify="end" align="end">
              <v-btn
                class="primary white--text mt-3"
                style="margin-left: 1em"
                @click="Add()"
                >
                <v-icon size="20" style="padding-right: 5px;">mdi-plus-circle-outline</v-icon>
                {{ $t("add") }}</v-btn
              >
            </v-col>
          </v-row>
          <v-data-table
            :items-per-page="itemsPerPage"
            :server-items-length="searchTotalTable"
            :options.sync="options"
            :items="menus"
            :headers="headers"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center;">{{ item.number }}</td>
                <td>{{ item.nodeName }}</td>
                <td>{{ isSubstring(item.prompt) }}</td>
                <td style="text-align: center;">
                  <v-btn icon @click="Edit(item)">
                    <img alt="img-edit" :src="images.edit" />
                  </v-btn>
                </td>
                <td style="text-align: center;">
                  <v-btn icon @click="DeleteGroup(item.modelNodeID)">
                    <img alt="img-delete" :src="images.delete" />
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <br />
        <br />
        <br />
      </v-card>
    </v-container>

    <!-- Add GPTModel -->
    <v-dialog v-model="Adddialog" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("addGPTModelNode") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      :label="'Prompt'"
                      outlined
                      counter
                      auto-grow
                      rows="65"
                      :maxlength="4000"
                      :messages="'4 char = 1 token'"
                      v-model="GPTModelNode.prompt"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Node name'"
                      v-model="GPTModelNode.nodeName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 1'"
                      v-model="GPTModelNode.role1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 1'"
                      v-model="GPTModelNode.content1"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 2'"
                      v-model="GPTModelNode.role2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 2'"
                      v-model="GPTModelNode.content2"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 3'"
                      v-model="GPTModelNode.role3"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 3'"
                      v-model="GPTModelNode.content3"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 4'"
                      v-model="GPTModelNode.role4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 4'"
                      v-model="GPTModelNode.content4"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 5'"
                      v-model="GPTModelNode.role5"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 5'"
                      v-model="GPTModelNode.content5"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Clear()">{{
            $t("close")
          }}</v-btn>
          <div v-show="true">
            <v-btn color="blue darken-1" text @click="Save()">{{
              $t("save")
            }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Search which user groups have which menus by check menu item -->
    <v-dialog v-model="EditdialogUser" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("updateGPTModelNode") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      :label="'Prompt'"
                      outlined
                      counter
                      auto-grow
                      rows="65"
                      :maxlength="4000"
                      :messages="'4 char = 1 token'"
                      v-model="GPTModelNode.prompt"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Node name'"
                      v-model="GPTModelNode.nodeName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 1'"
                      v-model="GPTModelNode.role1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 1'"
                      v-model="GPTModelNode.content1"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 2'"
                      v-model="GPTModelNode.role2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 2'"
                      v-model="GPTModelNode.content2"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 3'"
                      v-model="GPTModelNode.role3"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 3'"
                      v-model="GPTModelNode.content3"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 4'"
                      v-model="GPTModelNode.role4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 4'"
                      v-model="GPTModelNode.content4"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :label="'Role 5'"
                      v-model="GPTModelNode.role5"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      outlined
                      :label="'Content 5'"
                      v-model="GPTModelNode.content5"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Clear()">{{
            $t("close")
          }}</v-btn>
          <div v-show="true">
            <v-btn color="blue darken-1" text @click="Save()">{{
              $t("save")
            }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay  :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import call from "../api/call";
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
export default {
  name: "GPTModelNodeManagement",
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    checkbox1: false,
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    value: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {},
    groupList: null,
    groupList2: null,
    groupList3: null,
    groupList4: null,
    GroupList: [],
    GPTModelNode: {
      modelNodeID: null,
      nodeName: null,
      prompt: null,
      role1: null,
      content1: null,
      role2: null,
      content2: null,
      role3: null,
      content3: null,
      role4: null,
      content4: null,
      role5: null,
      content5: null,
    },
    searchNodeName: "",
    isSearch: false,
    isFirst: true,
    menusDDL: [
      { MenuName: "User Management" },
      { MenuName: "Menu Management" },
      {
        MenuName: "Calendar",
      },
    ],
    menus: [
      {
        id: 0,
        MenuName: "User Management",
        Submenus: [
          { id: 11, SubmenuName: "Users" },
          { id: 22, SubmenuName: "User Group" },
          { id: 33, SubmenuName: "Permission Management" },
        ],
      },
      {
        id: 1,
        MenuName: "Menu Management",
      },
      {
        id: 2,
        MenuName: "Calendar",
      },
      {
        id: 3,
        MenuName: "Log",
      },
    ],
    headers: [],
    images: {
      edit: require("@/assets/edit1.png"),
      delete: require("@/assets/delete1.png"),
    },
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
    },
  },
  methods: {
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.Get();
    },
    Get() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      const { page, itemsPerPage } = this.options;
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        nodeName: self.searchNodeName,
      };
      call.GetTableGPTModelNode(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      let self = this;
      self.dialog = true;
      try {
        if (self.Adddialog) {
          // axios
          //   .post(`${self.url}ManageGPTModel/AddGPTModel`, self.GPTModel)
          //   .then(function (response) {
          //     if (response.data.status == 0) {
          //       alert(response.data.message);
          //       window.location.reload();
          //     }
          //   })
          //   .catch(function (error) {
          //     alert(error);
          //     self.Adddialog = false;
          //     self.dialog = false;
          //   });
          call.AddGPTModelNode(
            self.GPTModelNode,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Adddialog = false;
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else if (self.EditdialogUser) {
          // axios
          //   .put(`${self.url}ManageGPTModel/UpdateGPTModel`, self.GPTModel)
          //   .then(function (response) {
          //     if (response.data.status == 0) {
          //       alert(response.data.message);
          //       window.location.reload();
          //     }
          //   })
          //   .catch(function (error) {
          //     alert(error);
          //     self.Adddialog = false;
          //     self.dialog = false;
          //   });
          call.UpdateGPTModelNode(
            self.GPTModelNode,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.EditdialogUser = false;
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    DeleteGroup(id) {
      try {
        let deleteconfirm = confirm("Are you sure to delete this data?");
        if (deleteconfirm == true) {
          let self = this;
          self.dialog = true;
          // axios
          //   .delete(`${self.url}ManageGPTModel/DeleteGPTModel?id=${id}`)
          //   .then(function (response) {
          //     if (response.data.status == 0) {
          //       alert(response.data.message);
          //       window.location.reload();
          //     }
          //   })
          //   .catch(function (error) {
          //     alert(error);
          //   });
          call.DeleteGPTModelNode(
            id,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.EditdialogUser = false;
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else {
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      let self = this;
      self.$router.push({
        name: "GPTModelInternalDetail",
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "GPTModelInternalDetail",
        query: {
          id: item.modelNodeID,
        },
      });
    },
    Clear() {
      let self = this;
      self.GPTModelNode.modelNodeID = null;
      self.GPTModelNode.nodeName = null;
      self.GPTModelNode.prompt = null;
      self.GPTModelNode.role1 = null;
      self.GPTModelNode.content1 = null;
      self.GPTModelNode.role2 = null;
      self.GPTModelNode.content2 = null;
      self.GPTModelNode.role3 = null;
      self.GPTModelNode.content3 = null;
      self.GPTModelNode.role4 = null;
      self.GPTModelNode.content4 = null;
      self.GPTModelNode.role5 = null;
      self.GPTModelNode.content5 = null;

      self.EditdialogUser = false;
      self.Adddialog = false;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isSubstring: function (text = "") {
      if (text.length > 60) {
        return text.substring(0, 60) + "...";
      }
      return text;
    },
  },
  mounted() {
    this.GetDate();
    this.headers = [{
        text: this.$t("no"),align: 'center',sortable: false,},
      { text: 'Model name',align: 'center',sortable: false, },
      { text: 'Prompt',align: 'center',sortable: false, },
      { text: this.$t("edit"),align: 'center',sortable: false, },
      { text: this.$t("delete"),align: 'center',sortable: false, }
    ];
    // this.Get();
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
</style>
